import type { IconProps } from './types';
import './icons.css';

export default function Expand({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-expand ${className || ''}`}
    >
      <path stroke="currentColor" d="M16 10H5M10.5 15.5v-11" />
    </svg>
  );
}
